module.exports = __webpack_public_path__ + "img/pc-bg.3d23cf35.jpg";